// 图一 5 个色号：把这 5 个颜色分配成一套统一配色方案
const PALETTE = {
  charcoalBlue: '#264653',
  verdigris: '#2A9D8F',
  jasmine: '#E9C46A',
  sandyBrown: '#F4A261',
  burntPeach: '#E76F51'
}

// 通用角色色：不同 UI 部位使用不同颜色
const ROLE_COLORS = {
  menuBg: PALETTE.charcoalBlue,
  menuText: '#ffffff',
  menuActiveText: '#ffffff',
  accent: PALETTE.jasmine,
  secondary: PALETTE.sandyBrown,
  danger: PALETTE.burntPeach,
  bodyBg: '#f5f7fa',
  headerBg: '#ffffff'
}

// 主题切换只改变“主色（按钮/激活态）”，其余角色固定使用上面这套搭配
export const THEME_LIST = [
  {
    key: 'charcoal-blue',
    name: 'Charcoal Blue',
    primary: PALETTE.charcoalBlue,
    light: '#e8eef0',
    hover: '#1b333d',
    textOnPrimary: '#ffffff'
  },
  {
    key: 'verdigris',
    name: 'Verdigris',
    primary: PALETTE.verdigris,
    light: '#e8f6f4',
    hover: '#218c7f',
    textOnPrimary: '#ffffff'
  },
  {
    key: 'jasmine',
    name: 'Jasmine',
    primary: PALETTE.jasmine,
    light: '#fcf6e8',
    hover: '#d9b55d',
    textOnPrimary: '#3d3d3d'
  },
  {
    key: 'sandy-brown',
    name: 'Sandy Brown',
    primary: PALETTE.sandyBrown,
    light: '#fdf2e8',
    hover: '#e08f4d',
    textOnPrimary: '#3d3d3d'
  },
  {
    key: 'burnt-peach',
    name: 'Burnt Peach',
    primary: PALETTE.burntPeach,
    light: '#fdf0ed',
    hover: '#d25e42',
    textOnPrimary: '#ffffff'
  }
]

export const DEFAULT_THEME = 'charcoal-blue'

export function applyTheme(themeKey) {
  if (themeKey) {
    document.documentElement.setAttribute('data-theme', themeKey)
  }
}

export function getThemeByKey(themeKey) {
  return THEME_LIST.find(t => t.key === themeKey) || THEME_LIST[0]
}

export { ROLE_COLORS, PALETTE }
